import Admin from "./Admin";
import Personal from "./Personal";
import Partner from "./Partner";

import React, { useState, useEffect, ChangeEventHandler, ChangeEvent, SyntheticEvent, KeyboardEvent, createContext } from "react";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Slider from '@mui/material/Slider';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import Icon from '@mui/material/Icon';
import WifiIcon from '@mui/icons-material/Wifi';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import {Route, Routes, useParams} from 'react-router-dom';

import axios from 'axios';
import { Buffer } from 'buffer';

// const baseURL = "http://localhost/rest";
const baseURL = "https://event.janeks.de/rest";

export default function Game() {
    const { userId, mode } = useParams();

      //const [guestName, setGuestName] = useState();
    const [adminFlag, setAdminFlag] = useState(0);
    const [value, setValue] = React.useState(0);
    const handleChange = (e, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        axios
      .post(
        baseURL+"/userlevel", {
          auth: mode,
        })
      .then((response) => {
            console.log(response.data);
            setAdminFlag(response.data.userlevel = 1 ? 1 : 0);
        }
      ).catch((error) => {
        console.log(error);
      });
    }, []);

    return (
<Box className="App">
    <Grid container direction="row" spacing={2} justifyContent="space-between" sx={{padding: 2}}>
        <Grid item>
          <Typography variant="h5" component="h1" color="primary">
            Party Game
          </Typography>
          </Grid>
      </Grid>
    <Grid container spacing={2}>
    <Grid item  xs={12} md={12}>
    <Card>{/* variant="outlined" */}

        {/* <Personal></Personal>

        <Partner></Partner> */}

        {/* <Poll></Poll> */}

        {/* <Accordion TransitionProps={{ unmountOnExit: true }} >
        <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
        >
            <Typography>Score board</Typography>
        </AccordionSummary>
        <AccordionDetails>
        </AccordionDetails>
        </Accordion> */}

        {adminFlag == 1 &&
        <Accordion>
            <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            >
            <Typography>Administration</Typography>
            </AccordionSummary>
            <AccordionDetails>
            <Admin></Admin>
            </AccordionDetails>
        </Accordion>
        }
    </Card>
    </Grid>

    {/* <Grid item xs={12} md={4}>
    <Card variant="outlined">
    </Card>
    </ Grid> */}

    {/* <Grid item xs={12}>
    <CardContent>
        <Typography variant="body1">
        <Button href="/api/node">node</Button>
        <Button href="/api/nodeconfig">nodeconfig</Button>
        </Typography>
    </CardContent>
    </ Grid>  */}
    </ Grid>
</Box>
    );
}